import React from "react";
import Container from "src/components/common/Layout/Container";
import { SubcategoriesSchema } from "src/models/category/getSubcategories";
import { colors } from "src/config/colors";
import { Grid, Pagination, PaginationItem, Typography } from "@mui/material";
import { SecondCategoriesSchema } from "src/models/secondCategories/getSecondCategories";
import SecondCategoriesCard from "src/components/SecondCategoriesPage/components/SecondCategoriesList/SecondCategoriesCard";
import SecondCategoriesFilter from "src/components/SecondCategoriesPage/components/SecondCategoriesFilter/SecondCategoriesFilter";
import { useSecondCategories } from "src/components/SecondCategoriesPage/hooks/useSecondCategories";
import { Box } from "@mui/system";
import Link from "src/components/common/Links/Link";
import { useQuery } from "src/utils/hooks/common/useQuery";
import CustomChipList from "src/components/common/CustomChipList/CustomChipList";
import DangerouslyHtml from "src/components/common/DangerouslyHtml/DangerouslyHtml";

interface SecondCategoriesPageProps {
  subcategories: SubcategoriesSchema[];
  secondCategoryData: SecondCategoriesSchema;
  pageTitle?: string;
}

const SecondCategoriesPage: React.FC<SecondCategoriesPageProps> = ({
  subcategories,
  pageTitle,
  secondCategoryData,
}) => {
  const { data, currentPage, changePageHref, isLoading } =
    useSecondCategories(secondCategoryData);

  const { city } = useQuery(["city"]);

  if (!secondCategoryData) return null;
  console.log(secondCategoryData)
  return (
    <Container isWithPaper>
      <Typography
        paddingY="20px"
        fontSize="30px"
        fontWeight={550}
        color={colors.darkBlue}
        component="h1"
        mb={2}
      >
        {pageTitle}
      </Typography>
      <CustomChipList city={city} data={subcategories} />
      <SecondCategoriesFilter />
      <Grid
        sx={{
          filter: isLoading ? "opacity(25%)" : "",
          paddingX: { xs: 1.5, lg: 0 },
        }}
        container
        spacing={2}
        mt={0}
        pb={2}
      >
        {data.items.map((value, index) => (
          <Grid key={index} item xs={12} md={4} sm={6} lg={3}>
            <SecondCategoriesCard
              image={value.image}
              mnn={value.mnn}
              isList
              min_price={value?.min_price}
              brandName={value.brand_name}
              slug={value.slug}
              pharmaciesAmount={value.pharmacies_amount}
              formsAmount={value.forms_amount}
            />
          </Grid>
        ))}
      </Grid>
      {data && data.paginator.totalPages > 1 && (
        <Box mt={3} display="flex" justifyContent="center" alignItems="center">
          <Pagination
            count={data.paginator.totalPages}
            page={Number(currentPage || 1)}
            color="secondary"
            renderItem={(item) => {
              if (item.disabled) return <PaginationItem {...item} />;

              return (
                <PaginationItem
                  component={Link}
                  shallow
                  scroll
                  href={changePageHref(item.page)}
                  {...item}
                />
              );
            }}
          />
        </Box>
      )}
      {secondCategoryData.html_text && (
        <DangerouslyHtml innerHtml={secondCategoryData.html_text} />
      )}
    </Container>
  );
};

export default SecondCategoriesPage;
